module.exports = __webpack_public_path__ + "static/wealthsimpleLogo-a5efdb187c529b5d0fc04aab7365977b.png";